// src/utils/userAxios.js
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import config from "../config";
import { store } from "../app/store";
import { logout } from "../features/authSlice";

const userAxios = axios.create({
  baseURL: `${config.url}/api`,
});

userAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      try {
        const { exp } = jwtDecode(token);
        const isExpired = Date.now() >= exp * 1000;
        if (isExpired) {
          store.dispatch(logout());
          localStorage.removeItem("authToken");
          window.location.href = "/login";
          throw new axios.Cancel("Session expired");
        }

        config.headers.Authorization = `Bearer ${token}`;
      } catch (err) {
        console.error("Token parse error:", err);
        store.dispatch(logout());
        localStorage.removeItem("authToken");
        window.location.href = "/login";
        throw new axios.Cancel("Invalid token");
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default userAxios;
